import { Pipe, PipeTransform } from '@angular/core';
import { ContentService } from '../services/content.service';

@Pipe({
  name: 'componentWrapStyle'
})
export class ComponentWrapStylePipe implements PipeTransform {
  constructor(private contentService: ContentService) {}
  transform(
    component: unknown,
    componentData?: string
  ): any[] {
    let componentWrapStyles = this.contentService.getComponentWrapStyle(component)
    return componentWrapStyles;
  }
}
